/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire, idProduct, isLloydsOrLima, setGenerateMRC1 }) {
  questionnaire.sort((a, b) => a.idQuestion - b.idQuestion);

  let showConnectionQst = false;

  questionnaire = questionnaire.map((question) => {
    if (question.idQuestion === 1942) {
      if (idProduct === 16) {
        question.disabled = true;
      } else if (isLloydsOrLima) {
        const filterOption = question.answerOptions?.find(opt => opt.idAnswerOption === 7592);
        if (filterOption && question.answer === '') {
          question.answer = filterOption.dsAnswerOption;
          question.idAnswerOption = filterOption.idAnswerOption;
        }
      }
      showConnectionQst = question.idAnswerOption === 7592;
    }

    if (question.idQuestion === 1943) {
      question.visibleQuestion = showConnectionQst ? 1 : 0;
      const filterOption = question.answerOptions?.find(opt => opt.idAnswerOption === (showConnectionQst ? 7594 : 7593));
      if (filterOption && question.answerJson === '') {
        question.answer = filterOption.dsAnswerOption;
        question.idAnswerOption = filterOption.idAnswerOption;
      }
      setGenerateMRC1(question.idAnswerOption === 7594);
    }

    return question;
  });

  return questionnaire;
};


async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete,
  setGenerateMRC1,
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1942) {
      saveQuestionnaire = true;

      const showConnectionQst = value.idAnswerOption === 7592;
      setGenerateMRC1(showConnectionQst)

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if ([1943].includes(qst.idQuestion)) {
          qst.visibleQuestion = value?.idAnswerOption !== 7591;

          const selectedOption = qst.answerOptions?.find((opt) => opt.idAnswerOption === 7594);

          if (selectedOption) {
            qst.answer = qst.answerJson = selectedOption.dsAnswerOption;
            qst.idAnswerOption = selectedOption.idAnswerOption;
            setFieldValue(qst.key, selectedOption.dsAnswerOption);
          }
        }

        if ([1961].includes(qst.idQuestion)) {
          const showAttachment = questionnaireUpdated.find(qst => qst.idQuestion === 1943)?.idAnswerOption === 7593;
          qst.visibleQuestion = value?.idAnswerOption !== 7591 && showAttachment;
          qst.hiddenInput = false;

          if (!qst.visibleQuestion) {

            if (qst.idQuestionnaireAnswers) {
              newQuestionnaireAnswersToDelete.push(qst.idQuestionnaireAnswers);
            }

            const attachment = qst?.answer?.length ? qst?.answer[0] : null;
            if (attachment) {
              newDocumentsToDelete.push(attachment.documentId)
            }

            qst.answer = null;
            qst.idAnswerOption = null;
            qst.answerJson = null;
            setFieldValue(qst.key, []);
          }
        }

        return qst;
      });
    }

    if (question.idQuestion === 1943) {
      saveQuestionnaire = true;

      const showAttachments = value.idAnswerOption === 7593;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if ([1961].includes(qst.idQuestion)) {
          qst.visibleQuestion = value?.idAnswerOption !== 7594;
          qst.hiddenInput = false;

          if (!qst.visibleQuestion) {
            if (qst.idQuestionnaireAnswers) {
              newQuestionnaireAnswersToDelete.push(qst.idQuestionnaireAnswers);
            }

            const attachment = qst?.answer?.length ? qst?.answer[0] : null;
            if (attachment) {
              newDocumentsToDelete.push(attachment.documentId)
            }

            qst.answer = null;
            qst.idAnswerOption = null;
            qst.answerJson = null;
            setFieldValue(qst.key, []);
          }
        }

        return qst
      })

      setGenerateMRC1(!showAttachments)
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('MRC1 - handleQuestionChange - error', e);
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
};

export { events };